// Dados completos das cartas de Tarô - Arcanos Maiores e Menores

export interface TarotCard {
  id: number;
  name: string;
  arcana: 'major' | 'minor';
  suit?: 'cups' | 'wands' | 'swords' | 'pentacles';
  number?: number;
  keywords: string[];
  meaning: {
    upright: string;
    reversed: string;
  };
  description: string;
  image?: string;
}

// Arcanos Maiores (22 cartas)
export const majorArcana: TarotCard[] = [
  {
    id: 0,
    name: "O Louco",
    arcana: "major",
    keywords: ["novo começo", "espontaneidade", "fé", "aventura"],
    meaning: {
      upright: "Novos começos, espontaneidade, inocência, espírito livre",
      reversed: "Imprudência, tomada de riscos, loucura, negligência"
    },
    description: "O Louco representa novos começos e a coragem de dar o primeiro passo em uma jornada desconhecida.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/olouco.png",
  },
  {
    id: 1,
    name: "O Mago",
    arcana: "major",
    keywords: ["manifestação", "poder pessoal", "ação", "concentração"],
    meaning: {
      upright: "Manifestação, força de vontade, desejo, criação, poder",
      reversed: "Manipulação, objetivos pobres, falta de direção"
    },
    description: "O Mago simboliza o poder de manifestar seus desejos através da força de vontade e ação.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/omago.png",
  },
  {
    id: 2,
    name: "A Sacerdotisa",
    arcana: "major",
    keywords: ["intuição", "mistério", "subconsciente", "sabedoria"],
    meaning: {
      upright: "Intuição, conhecimento sagrado, divino feminino, subconsciente",
      reversed: "Segredos, informação oculta, desconexão interior"
    },
    description: "A Sacerdotisa representa a sabedoria interior e a conexão com o subconsciente.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/asacerdotisa.png",
  },
  {
    id: 3,
    name: "A Imperatriz",
    arcana: "major",
    keywords: ["feminilidade", "beleza", "natureza", "abundância"],
    meaning: {
      upright: "Feminilidade, beleza, natureza, abundância, maternidade",
      reversed: "Dependência criativa, vazio, falta de crescimento"
    },
    description: "A Imperatriz simboliza a energia feminina criativa e a abundância da natureza.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/aimperatriz.png",
  },
  {
    id: 4,
    name: "O Imperador",
    arcana: "major",
    keywords: ["autoridade", "estrutura", "controle", "pai"],
    meaning: {
      upright: "Autoridade, estrutura, controle, figura paterna",
      reversed: "Tirania, rigidez, frieza, dominação"
    },
    description: "O Imperador representa autoridade, estrutura e o poder da liderança responsável.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/oimperador.png",
  },
  {
    id: 5,
    name: "O Hierofante",
    arcana: "major",
    keywords: ["tradição", "conformidade", "moralidade", "ética"],
    meaning: {
      upright: "Tradição, conformidade, moralidade, ética, conhecimento",
      reversed: "Rebelião, subversão, novas abordagens, ignorância"
    },
    description: "O Hierofante simboliza tradições espirituais e a busca por conhecimento sagrado.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/ohierofante.png",
  },
  {
    id: 6,
    name: "Os Amantes",
    arcana: "major",
    keywords: ["amor", "harmonia", "relacionamentos", "valores"],
    meaning: {
      upright: "Amor, harmonia, relacionamentos, valores, escolhas",
      reversed: "Desequilíbrio, conflito, desalinhamento de valores"
    },
    description: "Os Amantes representam união, escolhas importantes e alinhamento de valores.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/osnamorados.png",
  },
  {
    id: 7,
    name: "A Carruagem",
    arcana: "major",
    keywords: ["controle", "força de vontade", "sucesso", "determinação"],
    meaning: {
      upright: "Controle, força de vontade, sucesso, determinação, direção",
      reversed: "Falta de controle, falta de direção, agressão"
    },
    description: "A Carruagem simboliza triunfo através da força de vontade e determinação.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/ocarro.png",
  },
  {
    id: 8,
    name: "A Força",
    arcana: "major",
    keywords: ["força interior", "bravura", "compaixão", "foco"],
    meaning: {
      upright: "Força interior, bravura, compaixão, foco, persuasão",
      reversed: "Força bruta, abuso, falta de energia, falta de confiança"
    },
    description: "A Força representa o poder da compaixão e da força interior sobre a força bruta.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/aforca.png",
  },
  {
    id: 9,
    name: "O Eremita",
    arcana: "major",
    keywords: ["busca interior", "introspecção", "orientação", "solidão"],
    meaning: {
      upright: "Busca interior, introspecção, orientação, solidão",
      reversed: "Isolamento, solidão, retirada, paranoia"
    },
    description: "O Eremita simboliza a jornada interior em busca de sabedoria e iluminação.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/oeremita.png",
  },
  {
    id: 10,
    name: "A Roda da Fortuna",
    arcana: "major",
    keywords: ["boa sorte", "karma", "ciclos de vida", "destino"],
    meaning: {
      upright: "Boa sorte, karma, ciclos de vida, destino, ponto de virada",
      reversed: "Má sorte, falta de controle, quebra de ciclos"
    },
    description: "A Roda da Fortuna representa os ciclos da vida e as mudanças do destino.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/arodadafortuna.png",
  },
  {
    id: 11,
    name: "A Justiça",
    arcana: "major",
    keywords: ["justiça", "equidade", "verdade", "causa e efeito"],
    meaning: {
      upright: "Justiça, equidade, verdade, causa e efeito, lei",
      reversed: "Injustiça, falta de responsabilidade, desonestidade"
    },
    description: "A Justiça simboliza equilíbrio, verdade e as consequências de nossas ações.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/ajustica.png",
  },
  {
    id: 12,
    name: "O Enforcado",
    arcana: "major",
    keywords: ["suspensão", "restrição", "sacrifício", "nova perspectiva"],
    meaning: {
      upright: "Suspensão, restrição, sacrifício, nova perspectiva",
      reversed: "Atrasos, resistência, indecisão, falta de sacrifício"
    },
    description: "O Enforcado representa sacrifício voluntário e ganho de nova perspectiva.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/oenforcado.png",
  },
  {
    id: 13,
    name: "A Morte",
    arcana: "major",
    keywords: ["fim", "transformação", "transição", "renascimento"],
    meaning: {
      upright: "Fim, transformação, transição, renascimento",
      reversed: "Resistência à mudança, estagnação, decadência"
    },
    description: "A Morte simboliza transformação profunda e o fim de um ciclo para o início de outro.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/amorte.png",
  },
  {
    id: 14,
    name: "A Temperança",
    arcana: "major",
    keywords: ["equilíbrio", "moderação", "paciência", "propósito"],
    meaning: {
      upright: "Equilíbrio, moderação, paciência, propósito, significado",
      reversed: "Desequilíbrio, excesso, falta de propósito, impaciência"
    },
    description: "A Temperança representa equilíbrio, moderação e a arte da paciência.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/atemperanca.png",
  },
  {
    id: 15,
    name: "O Diabo",
    arcana: "major",
    keywords: ["escravidão", "vício", "sexualidade", "materialismo"],
    meaning: {
      upright: "Escravidão, vício, sexualidade, materialismo",
      reversed: "Libertação, liberdade, revelação, recuperação"
    },
    description: "O Diabo simboliza as correntes que criamos para nós mesmos e a necessidade de libertação.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/odiabo.png",
  },
  {
    id: 16,
    name: "A Torre",
    arcana: "major",
    keywords: ["mudança súbita", "reviravoltas", "caos", "revelação"],
    meaning: {
      upright: "Mudança súbita, reviravoltas, caos, revelação, despertar",
      reversed: "Evitar desastre, medo da mudança, resistência"
    },
    description: "A Torre representa mudanças súbitas e necessárias que destroem o antigo para construir o novo.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/atorre.png",
  },
  {
    id: 17,
    name: "A Estrela",
    arcana: "major",
    keywords: ["esperança", "fé", "propósito", "renovação"],
    meaning: {
      upright: "Esperança, fé, propósito, renovação, espiritualidade",
      reversed: "Falta de fé, desespero, desconexão, desânimo"
    },
    description: "A Estrela simboliza esperança, inspiração e conexão com o divino.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/aestrela.png",
  },
  {
    id: 18,
    name: "A Lua",
    arcana: "major",
    keywords: ["ilusão", "medo", "ansiedade", "subconsciente"],
    meaning: {
      upright: "Ilusão, medo, ansiedade, subconsciente, intuição",
      reversed: "Liberação do medo, verdade reprimida, superficialidade"
    },
    description: "A Lua representa ilusões, medos ocultos e a necessidade de confiar na intuição.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/alua.png",
  },
  {
    id: 19,
    name: "O Sol",
    arcana: "major",
    keywords: ["alegria", "sucesso", "celebração", "positividade"],
    meaning: {
      upright: "Alegria, sucesso, celebração, positividade, vitalidade",
      reversed: "Negatividade, depressão, tristeza, falta de sucesso"
    },
    description: "O Sol simboliza alegria, sucesso e a energia vital que ilumina nossa vida.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/osol.png",
  },
  {
    id: 20,
    name: "O Julgamento",
    arcana: "major",
    keywords: ["julgamento", "renascimento", "despertar interior", "perdão"],
    meaning: {
      upright: "Julgamento, renascimento, despertar interior, perdão",
      reversed: "Julgamento severo, falta de perdão, dúvida"
    },
    description: "O Julgamento representa renascimento espiritual e a capacidade de perdoar.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/ojulgamento.png",
  },
  {
    id: 21,
    name: "O Mundo",
    arcana: "major",
    keywords: ["conclusão", "realização", "viagem", "sucesso"],
    meaning: {
      upright: "Conclusão, realização, viagem, sucesso, realização",
      reversed: "Falta de conclusão, falta de realização, estagnação"
    },
    description: "O Mundo simboliza a conclusão bem-sucedida de uma jornada e a realização dos objetivos.",
    image: "https://res.cloudinary.com/dnkklol3i/image/upload/w_800,c_limit,f_auto,q_auto/tarot/arcanos_maiores/omundo.png",
  }
];

// Arcanos Menores - Copas (14 cartas)
export const cupsCards: TarotCard[] = [
  {
    id: 22,
    name: "Ás de Copas",
    arcana: "minor",
    suit: "cups",
    number: 1,
    keywords: ["novo amor", "compaixão", "criatividade", "intuição"],
    meaning: {
      upright: "Novo amor, compaixão, criatividade, intuição, novo relacionamento",
      reversed: "Bloqueio emocional, amor não correspondido, criatividade reprimida"
    },
    description: "O Ás de Copas representa novos começos emocionais e abertura do coração."
  },
  {
    id: 23,
    name: "Dois de Copas",
    arcana: "minor",
    suit: "cups",
    number: 2,
    keywords: ["união", "parceria", "conexão", "relacionamento"],
    meaning: {
      upright: "União, parceria, conexão, relacionamento, amor mútuo",
      reversed: "Desequilíbrio, relacionamento tóxico, separação"
    },
    description: "O Dois de Copas simboliza união harmoniosa e conexão emocional profunda."
  },
  {
    id: 24,
    name: "Três de Copas",
    arcana: "minor",
    suit: "cups",
    number: 3,
    keywords: ["celebração", "amizade", "comunidade", "alegria"],
    meaning: {
      upright: "Celebração, amizade, comunidade, alegria, festividade",
      reversed: "Excesso, fofoca, isolamento, terceira pessoa"
    },
    description: "O Três de Copas representa celebração, amizade e alegria compartilhada."
  },
  {
    id: 25,
    name: "Quatro de Copas",
    arcana: "minor",
    suit: "cups",
    number: 4,
    keywords: ["apatia", "contemplação", "descontentamento", "reavaliação"],
    meaning: {
      upright: "Apatia, contemplação, descontentamento, reavaliação",
      reversed: "Motivação renovada, interesse, consciência"
    },
    description: "O Quatro de Copas sugere a necessidade de reavaliar prioridades emocionais."
  },
  {
    id: 26,
    name: "Cinco de Copas",
    arcana: "minor",
    suit: "cups",
    number: 5,
    keywords: ["perda", "luto", "arrependimento", "pessimismo"],
    meaning: {
      upright: "Perda, luto, arrependimento, pessimismo, tristeza",
      reversed: "Aceitação, perdão, superação, otimismo"
    },
    description: "O Cinco de Copas representa luto e a necessidade de aceitar perdas para seguir em frente."
  },
  {
    id: 27,
    name: "Seis de Copas",
    arcana: "minor",
    suit: "cups",
    number: 6,
    keywords: ["nostalgia", "infância", "inocência", "memórias"],
    meaning: {
      upright: "Nostalgia, infância, inocência, memórias felizes",
      reversed: "Viver no passado, imaturidade, falta de progresso"
    },
    description: "O Seis de Copas evoca nostalgia e a importância das memórias da infância."
  },
  {
    id: 28,
    name: "Sete de Copas",
    arcana: "minor",
    suit: "cups",
    number: 7,
    keywords: ["ilusão", "escolhas", "fantasia", "confusão"],
    meaning: {
      upright: "Ilusão, escolhas, fantasia, confusão, sonhos",
      reversed: "Clareza, determinação, foco, realidade"
    },
    description: "O Sete de Copas representa ilusões e a dificuldade de escolher entre muitas opções."
  },
  {
    id: 29,
    name: "Oito de Copas",
    arcana: "minor",
    suit: "cups",
    number: 8,
    keywords: ["abandono", "busca", "jornada espiritual", "insatisfação"],
    meaning: {
      upright: "Abandono, busca, jornada espiritual, insatisfação",
      reversed: "Medo da mudança, estagnação, evitar problemas"
    },
    description: "O Oito de Copas simboliza deixar para trás o que não serve mais em busca de algo maior."
  },
  {
    id: 30,
    name: "Nove de Copas",
    arcana: "minor",
    suit: "cups",
    number: 9,
    keywords: ["satisfação", "contentamento", "realização", "felicidade"],
    meaning: {
      upright: "Satisfação, contentamento, realização, felicidade",
      reversed: "Insatisfação, ganância, materialismo, superficialidade"
    },
    description: "O Nove de Copas representa satisfação emocional e a realização de desejos."
  },
  {
    id: 31,
    name: "Dez de Copas",
    arcana: "minor",
    suit: "cups",
    number: 10,
    keywords: ["felicidade familiar", "harmonia", "realização emocional", "alegria"],
    meaning: {
      upright: "Felicidade familiar, harmonia, realização emocional, alegria",
      reversed: "Conflito familiar, valores quebrados, desarmonia"
    },
    description: "O Dez de Copas simboliza felicidade familiar e realização emocional completa."
  },
  {
    id: 32,
    name: "Valete de Copas",
    arcana: "minor",
    suit: "cups",
    number: 11,
    keywords: ["mensageiro emocional", "criatividade", "intuição", "sensibilidade"],
    meaning: {
      upright: "Mensageiro emocional, criatividade, intuição, sensibilidade",
      reversed: "Imaturidade emocional, mau humor, bloqueio criativo"
    },
    description: "O Valete de Copas representa mensagens emocionais e criatividade jovem."
  },
  {
    id: 33,
    name: "Cavaleiro de Copas",
    arcana: "minor",
    suit: "cups",
    number: 12,
    keywords: ["romance", "charme", "imaginação", "idealismo"],
    meaning: {
      upright: "Romance, charme, imaginação, idealismo, proposta",
      reversed: "Mau humor, ciúme, comportamento dramático"
    },
    description: "O Cavaleiro de Copas simboliza romance e a busca por ideais emocionais."
  },
  {
    id: 34,
    name: "Rainha de Copas",
    arcana: "minor",
    suit: "cups",
    number: 13,
    keywords: ["compaixão", "cuidado", "intuição", "sensibilidade"],
    meaning: {
      upright: "Compaixão, cuidado, intuição, sensibilidade emocional",
      reversed: "Dependência emocional, insegurança, manipulação"
    },
    description: "A Rainha de Copas representa compaixão maternal e sabedoria emocional."
  },
  {
    id: 35,
    name: "Rei de Copas",
    arcana: "minor",
    suit: "cups",
    number: 14,
    keywords: ["equilíbrio emocional", "compaixão", "diplomacia", "calma"],
    meaning: {
      upright: "Equilíbrio emocional, compaixão, diplomacia, calma",
      reversed: "Mau humor, manipulação emocional, volatilidade"
    },
    description: "O Rei de Copas simboliza maturidade emocional e liderança compassiva."
  }
];

// Arcanos Menores - Paus (14 cartas)
export const wandsCards: TarotCard[] = [
  {
    id: 36,
    name: "Ás de Paus",
    arcana: "minor",
    suit: "wands",
    number: 1,
    keywords: ["inspiração", "novo projeto", "crescimento", "potencial"],
    meaning: {
      upright: "Inspiração, novo projeto, crescimento, potencial, energia criativa",
      reversed: "Falta de energia, atrasos, frustração, falta de direção"
    },
    description: "O Ás de Paus representa nova inspiração e o potencial para crescimento criativo."
  },
  {
    id: 37,
    name: "Dois de Paus",
    arcana: "minor",
    suit: "wands",
    number: 2,
    keywords: ["planejamento", "decisões futuras", "poder pessoal", "progresso"],
    meaning: {
      upright: "Planejamento, decisões futuras, poder pessoal, progresso",
      reversed: "Falta de planejamento, medo do desconhecido, falta de controle"
    },
    description: "O Dois de Paus simboliza planejamento e a tomada de decisões sobre o futuro."
  },
  {
    id: 38,
    name: "Três de Paus",
    arcana: "minor",
    suit: "wands",
    number: 3,
    keywords: ["expansão", "previsão", "liderança", "comércio"],
    meaning: {
      upright: "Expansão, previsão, liderança, comércio, exploração",
      reversed: "Falta de previsão, atrasos, frustração, obstáculos"
    },
    description: "O Três de Paus representa expansão e a visão de longo prazo."
  },
  {
    id: 39,
    name: "Quatro de Paus",
    arcana: "minor",
    suit: "wands",
    number: 4,
    keywords: ["celebração", "harmonia", "casa", "comunidade"],
    meaning: {
      upright: "Celebração, harmonia, casa, comunidade, estabilidade",
      reversed: "Falta de apoio, instabilidade doméstica, conflitos"
    },
    description: "O Quatro de Paus simboliza celebração e harmonia no lar."
  },
  {
    id: 40,
    name: "Cinco de Paus",
    arcana: "minor",
    suit: "wands",
    number: 5,
    keywords: ["conflito", "competição", "tensão", "desacordo"],
    meaning: {
      upright: "Conflito, competição, tensão, desacordo, luta",
      reversed: "Evitar conflito, tensão interna, compromisso"
    },
    description: "O Cinco de Paus representa conflito e competição intensa."
  },
  {
    id: 41,
    name: "Seis de Paus",
    arcana: "minor",
    suit: "wands",
    number: 6,
    keywords: ["vitória", "sucesso", "reconhecimento", "progresso"],
    meaning: {
      upright: "Vitória, sucesso, reconhecimento, progresso, triunfo",
      reversed: "Falta de reconhecimento, atrasos, obstáculos privados"
    },
    description: "O Seis de Paus simboliza vitória e reconhecimento público."
  },
  {
    id: 42,
    name: "Sete de Paus",
    arcana: "minor",
    suit: "wands",
    number: 7,
    keywords: ["defesa", "perseverança", "manter posição", "desafios"],
    meaning: {
      upright: "Defesa, perseverança, manter posição, desafios",
      reversed: "Desistir, sentir-se sobrecarregado, falta de energia"
    },
    description: "O Sete de Paus representa defesa de sua posição contra desafios."
  },
  {
    id: 43,
    name: "Oito de Paus",
    arcana: "minor",
    suit: "wands",
    number: 8,
    keywords: ["velocidade", "ação rápida", "movimento", "progresso"],
    meaning: {
      upright: "Velocidade, ação rápida, movimento, progresso rápido",
      reversed: "Atrasos, frustração, falta de progresso, impaciência"
    },
    description: "O Oito de Paus simboliza movimento rápido e progresso acelerado."
  },
  {
    id: 44,
    name: "Nove de Paus",
    arcana: "minor",
    suit: "wands",
    number: 9,
    keywords: ["resistência", "persistência", "força interior", "determinação"],
    meaning: {
      upright: "Resistência, persistência, força interior, determinação",
      reversed: "Exaustão, paranoia, defensividade, obstinação"
    },
    description: "O Nove de Paus representa resistência e a força para continuar lutando."
  },
  {
    id: 45,
    name: "Dez de Paus",
    arcana: "minor",
    suit: "wands",
    number: 10,
    keywords: ["fardo", "responsabilidade", "trabalho duro", "estresse"],
    meaning: {
      upright: "Fardo, responsabilidade, trabalho duro, estresse",
      reversed: "Delegar, liberar fardos, trabalhar de forma mais inteligente"
    },
    description: "O Dez de Paus simboliza o peso das responsabilidades e trabalho duro."
  },
  {
    id: 46,
    name: "Valete de Paus",
    arcana: "minor",
    suit: "wands",
    number: 11,
    keywords: ["exploração", "aventura", "liberdade", "jornada"],
    meaning: {
      upright: "Exploração, aventura, liberdade, jornada, descoberta",
      reversed: "Falta de direção, imprudência, atrasos, frustração"
    },
    description: "O Valete de Paus representa espírito aventureiro e exploração."
  },
  {
    id: 47,
    name: "Cavaleiro de Paus",
    arcana: "minor",
    suit: "wands",
    number: 12,
    keywords: ["aventura", "impulsividade", "energia", "paixão"],
    meaning: {
      upright: "Aventura, impulsividade, energia, paixão, mudança",
      reversed: "Imprudência, impaciência, falta de autocontrole"
    },
    description: "O Cavaleiro de Paus simboliza energia impulsiva e paixão pela aventura."
  },
  {
    id: 48,
    name: "Rainha de Paus",
    arcana: "minor",
    suit: "wands",
    number: 13,
    keywords: ["confiança", "determinação", "independência", "vibração"],
    meaning: {
      upright: "Confiança, determinação, independência, vibração positiva",
      reversed: "Egoísmo, ciúme, insegurança, dependência"
    },
    description: "A Rainha de Paus representa confiança e determinação independente."
  },
  {
    id: 49,
    name: "Rei de Paus",
    arcana: "minor",
    suit: "wands",
    number: 14,
    keywords: ["liderança natural", "visão", "empreendedorismo", "honra"],
    meaning: {
      upright: "Liderança natural, visão, empreendedorismo, honra",
      reversed: "Imprudência, impaciência, tirania, arrogância"
    },
    description: "O Rei de Paus simboliza liderança natural e visão empreendedora."
  }
];

// Arcanos Menores - Espadas (14 cartas)
export const swordsCards: TarotCard[] = [
  {
    id: 50,
    name: "Ás de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 1,
    keywords: ["nova ideia", "clareza mental", "comunicação", "verdade"],
    meaning: {
      upright: "Nova ideia, clareza mental, comunicação, verdade, breakthrough",
      reversed: "Confusão, comunicação brutal, falta de clareza"
    },
    description: "O Ás de Espadas simboliza clareza mental e o poder das novas ideias."
  },
  {
    id: 51,
    name: "Dois de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 2,
    keywords: ["decisão difícil", "impasse", "escolha", "equilíbrio"],
    meaning: {
      upright: "Decisão difícil, impasse, escolha, equilíbrio, indecisão",
      reversed: "Confusão, informação falsa, adiamento de decisões"
    },
    description: "O Dois de Espadas representa decisões difíceis e a necessidade de escolher."
  },
  {
    id: 52,
    name: "Três de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 3,
    keywords: ["coração partido", "sofrimento", "traição", "dor"],
    meaning: {
      upright: "Coração partido, sofrimento, traição, dor emocional",
      reversed: "Recuperação, perdão, superação da dor"
    },
    description: "O Três de Espadas simboliza dor emocional e coração partido."
  },
  {
    id: 53,
    name: "Quatro de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 4,
    keywords: ["descanso", "contemplação", "paz", "recuperação"],
    meaning: {
      upright: "Descanso, contemplação, paz, recuperação, meditação",
      reversed: "Exaustão, burnout, falta de progresso"
    },
    description: "O Quatro de Espadas representa descanso e recuperação mental."
  },
  {
    id: 54,
    name: "Cinco de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 5,
    keywords: ["conflito", "derrota", "traição", "perda"],
    meaning: {
      upright: "Conflito, derrota, traição, perda, vitória vazia",
      reversed: "Reconciliação, fazer as pazes, perdão"
    },
    description: "O Cinco de Espadas simboliza conflito e vitória a um custo alto."
  },
  {
    id: 55,
    name: "Seis de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 6,
    keywords: ["transição", "mudança", "jornada", "progresso"],
    meaning: {
      upright: "Transição, mudança, jornada, progresso, movimento",
      reversed: "Resistência à mudança, águas turbulentas, atrasos"
    },
    description: "O Seis de Espadas representa transição e movimento para águas mais calmas."
  },
  {
    id: 56,
    name: "Sete de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 7,
    keywords: ["desonestidade", "traição", "roubo", "furtividade"],
    meaning: {
      upright: "Desonestidade, traição, roubo, furtividade, engano",
      reversed: "Confissão, honestidade, retorno do que foi roubado"
    },
    description: "O Sete de Espadas simboliza desonestidade e comportamento furtivo."
  },
  {
    id: 57,
    name: "Oito de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 8,
    keywords: ["restrição", "prisão", "limitação", "vítima"],
    meaning: {
      upright: "Restrição, prisão, limitação, sentir-se vítima",
      reversed: "Libertação, empoderamento, nova perspectiva"
    },
    description: "O Oito de Espadas representa sentir-se preso e limitado."
  },
  {
    id: 58,
    name: "Nove de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 9,
    keywords: ["ansiedade", "pesadelos", "medo", "culpa"],
    meaning: {
      upright: "Ansiedade, pesadelos, medo, culpa, preocupação",
      reversed: "Esperança, recuperação, superação do medo"
    },
    description: "O Nove de Espadas simboliza ansiedade e preocupações mentais."
  },
  {
    id: 59,
    name: "Dez de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 10,
    keywords: ["fim doloroso", "traição", "colapso", "fundo do poço"],
    meaning: {
      upright: "Fim doloroso, traição, colapso, fundo do poço",
      reversed: "Recuperação, regeneração, resistência, sobrevivência"
    },
    description: "O Dez de Espadas representa o fim doloroso de um ciclo."
  },
  {
    id: 60,
    name: "Valete de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 11,
    keywords: ["vigilância", "curiosidade", "espionagem", "mensagens"],
    meaning: {
      upright: "Vigilância, curiosidade, espionagem, mensagens",
      reversed: "Fofoca, mentiras, informações falsas"
    },
    description: "O Valete de Espadas representa vigilância e curiosidade mental."
  },
  {
    id: 61,
    name: "Cavaleiro de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 12,
    keywords: ["ação ambiciosa", "impulsividade", "determinação", "pressa"],
    meaning: {
      upright: "Ação ambiciosa, impulsividade, determinação, pressa",
      reversed: "Imprudência, falta de planejamento, agressividade"
    },
    description: "O Cavaleiro de Espadas simboliza ação impulsiva e determinação."
  },
  {
    id: 62,
    name: "Rainha de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 13,
    keywords: ["independência", "clareza", "percepção", "comunicação direta"],
    meaning: {
      upright: "Independência, clareza, percepção, comunicação direta",
      reversed: "Frieza, crueldade, amargura, ressentimento"
    },
    description: "A Rainha de Espadas representa independência e clareza mental."
  },
  {
    id: 63,
    name: "Rei de Espadas",
    arcana: "minor",
    suit: "swords",
    number: 14,
    keywords: ["autoridade intelectual", "verdade", "ética", "disciplina"],
    meaning: {
      upright: "Autoridade intelectual, verdade, ética, disciplina",
      reversed: "Manipulação, abuso de poder, tirania, crueldade"
    },
    description: "O Rei de Espadas simboliza autoridade intelectual e busca pela verdade."
  }
];

// Arcanos Menores - Ouros/Pentáculos (14 cartas)
export const pentaclesCards: TarotCard[] = [
  {
    id: 64,
    name: "Ás de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 1,
    keywords: ["nova oportunidade", "manifestação", "abundância", "prosperidade"],
    meaning: {
      upright: "Nova oportunidade, manifestação, abundância, prosperidade",
      reversed: "Oportunidade perdida, falta de planejamento, escassez"
    },
    description: "O Ás de Ouros representa novas oportunidades materiais e potencial de prosperidade."
  },
  {
    id: 65,
    name: "Dois de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 2,
    keywords: ["equilíbrio", "adaptabilidade", "prioridades", "flexibilidade"],
    meaning: {
      upright: "Equilíbrio, adaptabilidade, prioridades, flexibilidade",
      reversed: "Desequilíbrio, desorganização, sobrecarga"
    },
    description: "O Dois de Ouros simboliza a necessidade de equilibrar múltiplas responsabilidades."
  },
  {
    id: 66,
    name: "Três de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 3,
    keywords: ["trabalho em equipe", "colaboração", "habilidade", "construção"],
    meaning: {
      upright: "Trabalho em equipe, colaboração, habilidade, construção",
      reversed: "Falta de trabalho em equipe, competição, desorganização"
    },
    description: "O Três de Ouros representa colaboração e trabalho em equipe bem-sucedido."
  },
  {
    id: 67,
    name: "Quatro de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 4,
    keywords: ["segurança", "controle", "possessividade", "estabilidade"],
    meaning: {
      upright: "Segurança, controle, possessividade, estabilidade",
      reversed: "Generosidade, compartilhamento, liberação do controle"
    },
    description: "O Quatro de Ouros simboliza segurança material e controle financeiro."
  },
  {
    id: 68,
    name: "Cinco de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 5,
    keywords: ["dificuldade financeira", "pobreza", "isolamento", "preocupação"],
    meaning: {
      upright: "Dificuldade financeira, pobreza, isolamento, preocupação",
      reversed: "Recuperação financeira, melhoria, esperança"
    },
    description: "O Cinco de Ouros representa dificuldades financeiras e necessidade de ajuda."
  },
  {
    id: 69,
    name: "Seis de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 6,
    keywords: ["generosidade", "caridade", "compartilhamento", "reciprocidade"],
    meaning: {
      upright: "Generosidade, caridade, compartilhamento, reciprocidade",
      reversed: "Egoísmo, dívidas, desequilíbrio no dar e receber"
    },
    description: "O Seis de Ouros simboliza generosidade e o equilíbrio entre dar e receber."
  },
  {
    id: 70,
    name: "Sete de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 7,
    keywords: ["paciência", "perseverança", "investimento a longo prazo", "avaliação"],
    meaning: {
      upright: "Paciência, perseverança, investimento a longo prazo, avaliação",
      reversed: "Impaciência, falta de recompensa, frustração"
    },
    description: "O Sete de Ouros representa paciência e avaliação de progresso a longo prazo."
  },
  {
    id: 71,
    name: "Oito de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 8,
    keywords: ["habilidade", "artesanato", "dedicação", "aperfeiçoamento"],
    meaning: {
      upright: "Habilidade, artesanato, dedicação, aperfeiçoamento",
      reversed: "Falta de foco, perfeccionismo, falta de ambição"
    },
    description: "O Oito de Ouros simboliza dedicação ao aperfeiçoamento de habilidades."
  },
  {
    id: 72,
    name: "Nove de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 9,
    keywords: ["abundância", "luxo", "independência financeira", "autossuficiência"],
    meaning: {
      upright: "Abundância, luxo, independência financeira, autossuficiência",
      reversed: "Dependência financeira, superficialidade, falta de disciplina"
    },
    description: "O Nove de Ouros representa abundância e independência financeira."
  },
  {
    id: 73,
    name: "Dez de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 10,
    keywords: ["riqueza", "herança", "família", "tradição"],
    meaning: {
      upright: "Riqueza, herança, família, tradição, legado",
      reversed: "Problemas financeiros familiares, perda de tradições"
    },
    description: "O Dez de Ouros simboliza riqueza familiar e legado duradouro."
  },
  {
    id: 74,
    name: "Valete de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 11,
    keywords: ["oportunidade", "manifestação", "estudante", "mensagem"],
    meaning: {
      upright: "Oportunidade, manifestação, estudante, mensagem sobre dinheiro",
      reversed: "Falta de progresso, procrastinação, falta de compromisso"
    },
    description: "O Valete de Ouros representa novas oportunidades e aprendizado prático."
  },
  {
    id: 75,
    name: "Cavaleiro de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 12,
    keywords: ["eficiência", "trabalho duro", "produtividade", "rotina"],
    meaning: {
      upright: "Eficiência, trabalho duro, produtividade, rotina",
      reversed: "Preguiça, obsessão pelo trabalho, perfeccionismo"
    },
    description: "O Cavaleiro de Ouros simboliza trabalho duro e dedicação metódica."
  },
  {
    id: 76,
    name: "Rainha de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 13,
    keywords: ["praticidade", "cuidado", "segurança", "abundância"],
    meaning: {
      upright: "Praticidade, cuidado, segurança, abundância, generosidade",
      reversed: "Dependência financeira, ciúme, superficialidade"
    },
    description: "A Rainha de Ouros representa praticidade e cuidado com recursos."
  },
  {
    id: 77,
    name: "Rei de Ouros",
    arcana: "minor",
    suit: "pentacles",
    number: 14,
    keywords: ["abundância", "segurança financeira", "disciplina", "generosidade"],
    meaning: {
      upright: "Abundância, segurança financeira, disciplina, generosidade",
      reversed: "Ganância, materialismo, corrupção financeira"
    },
    description: "O Rei de Ouros simboliza sucesso financeiro e generosidade responsável."
  }
];

const _CDN = 'https://res.cloudinary.com/dnkklol3i/image/upload/e_trim:20';
const _SUIT_FOLDER: Record<string, string> = { cups: 'copas', wands: 'paus', swords: 'espadas', pentacles: 'ouros' };
const _SUIT_SUFFIX: Record<string, string> = { cups: 'decopas', wands: 'depaus', swords: 'deespadas', pentacles: 'deouro' };
const _RANK_PREFIX: Record<number, string> = { 1: 'as', 11: 'pajem', 12: 'cavaleiro', 13: 'rainha', 14: 'rei' };
const _EXCEPTIONS: Record<string, string> = {
  'swords_8':  '8deaspadas',
  'swords_11': 'pajemdeaspadas',
  'pentacles_12': 'cavaleiodeouro',
};

function _minorImageUrl(suit: string, number: number): string {
  const key = `${suit}_${number}`;
  const stem = _EXCEPTIONS[key] ?? (_RANK_PREFIX[number] ?? String(number)) + _SUIT_SUFFIX[suit];
  return `${_CDN}/tarot/${_SUIT_FOLDER[suit]}/${stem}.png`;
}

// Todas as cartas combinadas
export const allTarotCards: TarotCard[] = [
  ...majorArcana,
  ...cupsCards,
  ...wandsCards,
  ...swordsCards,
  ...pentaclesCards
].map(card => {
  if (!card.image && card.arcana === 'minor' && card.suit && card.number !== undefined) {
    return { ...card, image: _minorImageUrl(card.suit, card.number) };
  }
  return card;
});

// Função para embaralhar cartas
export const shuffleCards = (cards: TarotCard[]): TarotCard[] => {
  const shuffled = [...cards];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

// Função para selecionar cartas aleatórias
export const selectRandomCards = (count: number, cards: TarotCard[] = allTarotCards): TarotCard[] => {
  const shuffled = shuffleCards(cards);
  return shuffled.slice(0, count);
};